import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./EditEmployeePage.css";

const EditEmployeePage = ({ selectedBusiness }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const businessId = selectedBusiness?.id;
    const employeeId = location.state?.employeeId;

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [hire_date, setHireDate] = useState("");
    const [dob, setDob] = useState("");
    const [ssn, setSsn] = useState("");
    const [filingStatus, setFilingStatus] = useState("");
    const [dependents, setDependents] = useState(0);
    const [additionalFedTax, setAdditionalFedTax] = useState(0);
    const [additionalStateTax, setAdditionalStateTax] = useState(0);
    const [eStAdd, setEStAdd] = useState("");
    const [eSuite, setESuite] = useState("");
    const [eState, setEState] = useState("");
    const [eCity, setECity] = useState("");
    const [eZip, setEZip] = useState("");
    const [workType, setWorkType] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [amount, setAmount] = useState("");
    const [employerState, setEmployerState] = useState("");
    const [eCounty, setECounty] = useState("");
    const [chargesCountyTax, setChargesCountyTax] = useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]);
    const [convenienceRuleApplies, setConvenienceRuleApplies] = useState(false);
    const [employerMandated, setEmployerMandated] = useState("");
    const [loading, setLoading] = useState(true);

    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");

    const [paymentIssueType, setPaymentIssueType] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [routingNumber, setRoutingNumber] = useState("");
    const [schoolDistricts, setSchoolDistricts] = useState([]);
const [schoolDistrictNo, setSchoolDistrictNo] = useState("");

    const [email, setEmail] = useState("");

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const { data } = await api.get(`/business/${businessId}/departments`);
                setDepartments(data);
            } catch (error) {
                console.error("Error fetching departments:", error);
            }
        };
        fetchDepartments();
    }, [businessId]);

    useEffect(() => {
        const fetchEmployerState = async () => {
            try {
                const response = await api.get(`/businesses/${businessId}`);
                setEmployerState(response.data.b_state);
            } catch (error) {
                console.error("Error fetching employer's state:", error);
            }
        };
        fetchEmployerState();
    }, [businessId]);

    useEffect(() => {
        const fetchStates = async () => {
            try {
                const { data } = await api.get("/states");
                setStates(data);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);

    useEffect(() => {
        if (employerState) {
            const selectedState = states.find((state) => state.st_code === employerState);
            setConvenienceRuleApplies(selectedState?.convenience_rule_applies || false);
        }
    }, [employerState, states]);

    useEffect(() => {
        if (!businessId || !employeeId) {
        navigate("/dashboard/business/employees", { replace: true });
        return;
    }
        const fetchEmployeeDetails = async () => {
            if (states.length === 0) return;

            try {
                const { data } = await api.get(`/business/${businessId}/employees/${employeeId}`);

                const selectedState = states.find((state) => state.st_code === data.e_state);

                setSelectedDepartment(data.department_id || "");
                setFirstName(data.first_name || "");
                setLastName(data.last_name || "");
                setDob(data.dob ? new Date(data.dob).toISOString().split("T")[0] : "");
                setHireDate(data.hire_date ? new Date(data.hire_date).toISOString().split("T")[0] : "");
                setSsn("");
                setEmail(data.email || "");
                setFilingStatus(data.filing_status || "");
                setDependents(data.dependents ?? 0);
                setAdditionalFedTax(data.additional_fed_tax ?? 0);
                setAdditionalStateTax(data.additional_state_tax ?? 0);
                setEStAdd(data.e_st_add || "");
                setESuite(data.e_suite || "");
                setEState(data.e_state || "");
                setECity(data.e_city || "");
                setEZip(data.e_zip || "");
                setWorkType(data.work_loc || "");
                setPaymentType(data.salary_amt !== null ? "salary" : "hourly");
                setAmount(data.salary_amt ?? data.hourly_amt ?? "");
                setEmployerMandated(data.employer_mandated ? "yes" : "no");
                setECounty(data.e_county || "");
                setSchoolDistrictNo(data.school_district_no ? String(data.school_district_no) : "");

                setPaymentIssueType(data.is_direct_dep ? "Direct Deposit" : "Print Paycheck");
                setAccountNumber("");
                setRoutingNumber("");

                if (selectedState?.charges_countytax) {
                    setChargesCountyTax(true);
                    fetchCounties(data.e_state);
                } else {
                    setChargesCountyTax(false);
                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching employee details:", error);
                alert("Failed to load employee details.");
                navigate(`/dashboard/business/employees`);
            }
        };

        fetchEmployeeDetails();
    }, [businessId, employeeId, states, navigate]);

    useEffect(() => {
        if (eState) {
            const fetchCities = async () => {
                try {
                    const { data } = await api.get(`/cities/${eState}`);
                    setCities(data);
                } catch (error) {
                    console.error("Error fetching cities:", error);
                }
            };
            fetchCities();
        }
    }, [eState]);

    useEffect(() => {
        if (eState) {
            fetchCounties(eState);
        }
    }, [eState]);

    const fetchCounties = async (stateCode) => {
        try {
            const response = await api.get(`/counties/${stateCode}`);
            setCounties(response.data);
        } catch (error) {
            console.error("Error fetching counties:", error);
        }
    };

    useEffect(() => {
    const fetchSchoolDistricts = async () => {
        if (eState === "OH") {
            try {
                const { data } = await api.get("/ohio-school-districts");
                setSchoolDistricts(data);
            } catch (error) {
                console.error("Error fetching Ohio school districts:", error);
            }
        } else {
            setSchoolDistricts([]);
            setSchoolDistrictNo("");
        }
    };

    fetchSchoolDistricts();
}, [eState]);

    const handleStateChange = (e) => {
        const selectedState = states.find((state) => state.st_code === e.target.value);
        setEState(selectedState.st_code);

        if (selectedState.charges_countytax) {
            setChargesCountyTax(true);
            fetchCounties(selectedState.st_code);
        } else {
            setChargesCountyTax(false);
            setCounties([]);
            setECounty("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!paymentType || !amount) {
            alert("Please select a payment type and enter the corresponding amount.");
            return;
        }

        const requestData = {
            first_name: firstName,
            last_name: lastName,
            dob,
            hire_date,
            email,
            filing_status: filingStatus,
            dependents,
            additional_fed_tax: additionalFedTax,
            additional_state_tax: additionalStateTax,
            e_st_add: eStAdd,
            e_suite: eSuite,
            e_state: eState,
            e_city: eCity,
            e_county: eCounty || null,
            school_district_no: eState === "OH" ? schoolDistrictNo : null,
            e_zip: eZip,
            works_home: workType,
            payment_type: paymentType,
            salary_amt: paymentType === "salary" ? amount : null,
            hourly_amt: paymentType === "hourly" ? amount : null,
            employer_mandated: convenienceRuleApplies && workType === "home" ? (employerMandated === "yes" ? 1 : 0) : null,
            department_id: selectedDepartment ? parseInt(selectedDepartment, 10) : null,
            is_direct_dep: paymentIssueType === "Direct Deposit" ? 1 : 0
        };

        if (ssn.trim()) {
            requestData.ssn = ssn.trim();
        }

        if (paymentIssueType === "Direct Deposit") {
            if ((accountNumber && !routingNumber) || (!accountNumber && routingNumber)) {
                alert("Please enter both account number and routing number, or leave both blank.");
                return;
            }

            if (accountNumber.trim()) {
                requestData.account_number = accountNumber.trim();
            }

            if (routingNumber.trim()) {
                requestData.routing_number = routingNumber.trim();
            }
        }

        try {
            await api.put(`/employees/${employeeId}`, requestData);
            alert("Employee updated successfully!");
            navigate(`/dashboard/business/employees`);
        } catch (error) {
            console.error("Error updating employee:", error);
            alert(error.response?.data || "Failed to update employee. Please try again.");
        }
    };

    const handleDisable = async () => {
        if (window.confirm("Are you sure you want to disable this employee?")) {
            try {
                await api.put(`/employees/${employeeId}/disable`);
                alert("Employee disabled successfully.");
                navigate(`/dashboard/business/employees`);
            } catch (error) {
                console.error("Error disabling employee:", error);
                alert("Failed to disable employee.");
            }
        }
    };

    const handleSsnChange = (value) => {
        const numericValue = value.replace(/\D/g, "");

        let formattedValue = numericValue;
        if (numericValue.length > 3) {
            formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
        }
        if (numericValue.length > 5) {
            formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3, 5)}-${numericValue.slice(5)}`;
        }

        setSsn(formattedValue.slice(0, 11));
    };

    if (loading) return <p className="loading">Loading employee details... Please wait.</p>;

    return (
        <div className="edit-employee-container">
            <h2 className="page-header-edit">Edit Employee</h2>

            <button className="disable-button" onClick={handleDisable}>
                Disable Employee
            </button>

            <form className="edit-employee-form" onSubmit={handleSubmit}>
                <label className="addemplabel">
                    Department:
                    <select
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                        required
                    >
                        <option value="">Select Department</option>
                        {departments.map((dept) => (
                            <option key={dept.id} value={dept.id}>
                                {dept.department_name} ({dept.department_short})
                            </option>
                        ))}
                    </select>
                </label>

                <label className="addemplabel">
                    Payment Issue Type:
                    <select value={paymentIssueType} onChange={(e) => setPaymentIssueType(e.target.value)} required>
                        <option value="">Select Payment Issue Type</option>
                        <option value="Print Paycheck">Print Paycheck</option>
                        <option value="Direct Deposit">Direct Deposit</option>
                    </select>
                </label>

                {paymentIssueType === "Direct Deposit" && (
                    <>
                        <label className="addemplabel">
                            Account Number:
                            <input
                                type="text"
                                value={accountNumber}
                                onChange={(e) => setAccountNumber(e.target.value)}
                                placeholder="Enter new account number only if changing it"
                            />
                            <small className="field-note">
                                Leave blank to keep the current account number unchanged.
                            </small>
                        </label>

                        <label className="addemplabel">
                            Routing Number:
                            <input
                                type="text"
                                value={routingNumber}
                                onChange={(e) => setRoutingNumber(e.target.value)}
                                placeholder="Enter new routing number only if changing it"
                            />
                            <small className="field-note">
                                Leave blank to keep the current routing number unchanged.
                            </small>
                        </label>
                    </>
                )}

                <label className="addemplabel">
                    First Name:
                    <input value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                </label>

                <label className="addemplabel">
                    Last Name:
                    <input value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                </label>

                <label className="addemplabel">
                    Date of Hire:
                    <input value={hire_date} onChange={(e) => setHireDate(e.target.value)} type="date" required />
                </label>

                <label className="addemplabel">
                    Date of Birth:
                    <input value={dob} onChange={(e) => setDob(e.target.value)} type="date" required />
                </label>

                <label className="addemplabel">
                    SSN:
                    <input
                        value={ssn}
                        onChange={(e) => handleSsnChange(e.target.value)}
                        placeholder="Enter new SSN only if changing it"
                    />
                    <small className="field-note">
                        If editing the SSN, enter the new SSN. Otherwise leave this field blank to keep the current SSN unchanged.
                    </small>
                </label>

                <label className="addemplabel">
                    Email:
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </label>

                <label className="addemplabel">
                    Filing Status:
                    <select value={filingStatus} onChange={(e) => setFilingStatus(e.target.value)} required>
                        <option value="">Select Filing Status</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Head of Household">Head of Household</option>
                    </select>
                </label>

                <label className="addemplabel">
                    Dependents:
                    <input value={dependents} onChange={(e) => setDependents(e.target.value)} type="number" />
                </label>

                <label className="addemplabel">
                    Additional Federal Tax:
                    <input value={additionalFedTax} onChange={(e) => setAdditionalFedTax(e.target.value)} type="number" />
                </label>

                <label className="addemplabel">
                    Additional State Tax:
                    <input value={additionalStateTax} onChange={(e) => setAdditionalStateTax(e.target.value)} type="number" />
                </label>

                <label className="addemplabel">
                    Street Address:
                    <input value={eStAdd} onChange={(e) => setEStAdd(e.target.value)} required />
                </label>

                <label className="addemplabel">
                    Suite:
                    <input value={eSuite} onChange={(e) => setESuite(e.target.value)} />
                </label>

                <label className="addemplabel address-row">
                    State:
                    <select value={eState} onChange={handleStateChange} required>
                        <option value="">Select State</option>
                        {states.map((state) => (
                            <option key={state.st_code} value={state.st_code}>
                                {state.st_name}
                            </option>
                        ))}
                    </select>
                </label>

                {chargesCountyTax && (
                    <label className="addemplabel address-row">
                        County:
                        <select
                            value={eCounty || ""}
                            onChange={(e) => setECounty(e.target.value)}
                            required
                        >
                            <option value="">Select County</option>
                            {counties.map((county, index) => (
                                <option key={index} value={county.county_name}>
                                    {county.county_name}
                                </option>
                            ))}
                        </select>
                    </label>
                )}


                {eState === "OH" && (
    <label className="addemplabel address-row">
        School District:
        <select
            value={schoolDistrictNo}
            onChange={(e) => setSchoolDistrictNo(e.target.value)}
            required
        >
            <option value="">Select School District</option>
            {schoolDistricts.map((district) => (
                <option
                    key={district.district_number}
                    value={district.district_number}
                >
                    {district.district_name} - {district.district_number}
                </option>
            ))}
        </select>
    </label>
)}

                <label className="addemplabel">
                    City:
                    <select value={eCity} onChange={(e) => setECity(e.target.value)} required>
                        <option value="">Select City</option>
                        {cities.map((city, index) => (
                            <option key={index} value={city.city_name}>
                                {city.city_name}
                            </option>
                        ))}
                    </select>
                </label>

                <label className="addemplabel">
                    ZIP Code:
                    <input value={eZip} onChange={(e) => setEZip(e.target.value)} required />
                </label>

                <label className="addemplabel">
                    Work Location:
                    <select value={workType} onChange={(e) => setWorkType(e.target.value)} required>
                        <option value="">Select Work Location</option>
                        <option value="bus">Works at business location</option>
                        <option value="home">Works from home</option>
                    </select>
                </label>

                {convenienceRuleApplies && workType === "home" && (
                    <label className="addemplabel">
                        Is Remote Work Employer-Mandated?
                        <select
                            value={employerMandated}
                            onChange={(e) => setEmployerMandated(e.target.value)}
                            required
                        >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </select>
                    </label>
                )}

                <label className="addemplabel">
                    Payment Type:
                    <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)} required>
                        <option value="">Select Payment Type</option>
                        <option value="salary">Salary</option>
                        <option value="hourly">Hourly</option>
                    </select>
                </label>

                {paymentType && (
                    <label className="addemplabel">
                        {paymentType === "salary" ? "Salary per year" : "Hourly Rate"}:
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            required
                        />
                    </label>
                )}

                <div className="form-buttons">
                    <button className="save-button" type="submit">
                        Save
                    </button>
                    <button
                        className="cancel-button"
                        type="button"
                        onClick={() => navigate(`/dashboard/business/employees`)}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditEmployeePage;



// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import "./EditEmployeePage.css"; // Import the CSS file for styling

// const EditEmployeePage = () => {
//     const { id: businessId, employeeId } = useParams();
//     const navigate = useNavigate();

//     const [firstName, setFirstName] = useState("");
//     const [lastName, setLastName] = useState("");
//     const [hire_date, setHireDate] = useState("");
//     const [dob, setDob] = useState("");
//     const [ssn, setSsn] = useState("");
//     const [filingStatus, setFilingStatus] = useState("");
//     const [dependents, setDependents] = useState(0);
//     const [additionalFedTax, setAdditionalFedTax] = useState(0);
//     const [additionalStateTax, setAdditionalStateTax] = useState(0);
//     const [eStAdd, setEStAdd] = useState("");
//     const [eSuite, setESuite] = useState("");
//     const [eState, setEState] = useState("");
//     const [eCity, setECity] = useState("");
//     const [eZip, setEZip] = useState("");
//     const [workType, setWorkType] = useState("");
//     const [paymentType, setPaymentType] = useState("");
//     const [amount, setAmount] = useState("");
//     const [employerState, setEmployerState] = useState("");
//     const [eCounty, setECounty] = useState(""); // NEW: State for County
//     const [chargesCountyTax, setChargesCountyTax] = useState(false);
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [counties, setCounties] = useState([]); // NEW: State to hold counties
//     const [convenienceRuleApplies, setConvenienceRuleApplies] = useState(false);
//     const [employerMandated, setEmployerMandated] = useState("");
//     const [loading, setLoading] = useState(true);

//     const [departments, setDepartments] = useState([]);
//     const [selectedDepartment, setSelectedDepartment] = useState("");
//     // New State for Direct Deposit
//     const [paymentIssueType, setPaymentIssueType] = useState("");
//     const [accountNumber, setAccountNumber] = useState("");
//     const [routingNumber, setRoutingNumber] = useState("");

//     const [email, setEmail] = useState("");




//     useEffect(() => {
//         const fetchDepartments = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/departments`);
//                 setDepartments(data);
//             } catch (error) {
//                 console.error("Error fetching departments:", error);
//             }
//         };
//         fetchDepartments();
//     }, [businessId]);




//     useEffect(() => {
//         if (eState) {
//             const fetchCounties = async () => {
//                 try {
//                     const response = await api.get(`/counties/${eState}`);
//                     console.log("Counties fetched for state:", response.data);
//                     setCounties(response.data);
//                 } catch (error) {
//                     console.error("Error fetching counties:", error);
//                 }
//             };
//             fetchCounties();
//         }
//     }, [eState]);




//     useEffect(() => {
//         const fetchEmployerState = async () => {
//             try {
//                 const response = await api.get(`/businesses/${businessId}`);
//                 setEmployerState(response.data.b_state); // Assuming the response includes the employer's state
//             } catch (error) {
//                 console.error("Error fetching employer's state:", error);
//             }
//         };
//         fetchEmployerState();
//     }, [businessId]);

//     useEffect(() => {
//         const checkConvenienceRule = () => {
//             if (employerState) {
//                 const selectedState = states.find((state) => state.st_code === employerState);
//                 setConvenienceRuleApplies(selectedState?.convenience_rule_applies || false);
//             }
//         };
//         checkConvenienceRule();
//     }, [employerState, states]);

//     useEffect(() => {
//         const fetchStates = async () => {
//             try {
//                 const { data } = await api.get("/states");
//                 setStates(data);
//             } catch (error) {
//                 console.error("Error fetching states:", error);
//             }
//         };
//         fetchStates();
//     }, []);

//     useEffect(() => {
//         if (eState) {
//             const fetchCounties = async () => {
//                 try {
//                     const response = await api.get(`/counties/${eState}`);
//                     console.log("Counties fetched for state:", response.data); // Debug log
//                     setCounties(response.data);
//                 } catch (error) {
//                     console.error("Error fetching counties:", error);
//                 }
//             };
//             fetchCounties();
//         }
//     }, [eState]);
    

   

//     useEffect(() => {
//         const fetchEmployeeDetails = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/employees/${employeeId}`);
//                 console.log("Employee Details:", data);
    
//                 const selectedState = states.find((state) => state.st_code === data.e_state);

//                 setSelectedDepartment(data.department_id || "");
//                 setFirstName(data.first_name);
//                 setLastName(data.last_name);
//                 setDob(new Date(data.dob).toISOString().split("T")[0]);
//                 setHireDate(new Date(data.hire_date).toISOString().split("T")[0]);
//                 setSsn(data.ssn);
//                 setEmail(data.email || "");
//                 setFilingStatus(data.filing_status);
//                 setDependents(data.dependents);
//                 setAdditionalFedTax(data.additional_fed_tax);
//                 setAdditionalStateTax(data.additional_state_tax);
//                 setEStAdd(data.e_st_add);
//                 setESuite(data.e_suite);
//                 setEState(data.e_state);
//                 setECity(data.e_city);
//                 setEZip(data.e_zip);
//                 setWorkType(data.work_loc);
//                 setPaymentType(data.salary_amt !== null ? "salary" : "hourly");
//                 setAmount(data.salary_amt ?? data.hourly_amt);
//                 setEmployerMandated(data.employer_mandated !== null ? "yes" : "no");
//                 setECounty(data.e_county);

//                 // ✅ Set Direct Deposit Fields
//                 setPaymentIssueType(data.is_direct_dep ? "Direct Deposit" : "Print Paycheck");
//                 setAccountNumber(data.account_number || "");
//                 setRoutingNumber(data.routing_number || "");

    
//                 // Handle county tax logic
//                 if (selectedState?.charges_countytax) {
//                     setChargesCountyTax(true);
//                     fetchCounties(data.e_state); // Fetch counties for the employee's state
//                 } else {
//                     setChargesCountyTax(false);
//                 }
    
//                 setLoading(false);
//             } catch (error) {
//                 console.error("Error fetching employee details:", error);
//                 alert("Failed to load employee details.");
//                 navigate(`/dashboard/business/${businessId}/employees`);
//             }
//         };
//         fetchEmployeeDetails();
//     }, [businessId, employeeId, states, navigate]);
    

//     useEffect(() => {
//         const fetchCities = async () => {
//             if (eState) {
//                 try {
//                     const { data } = await api.get(`/cities/${eState}`);
//                     setCities(data);
//                 } catch (error) {
//                     console.error("Error fetching cities:", error);
//                 }
//             }
//         };
//         fetchCities();
//     }, [eState]);

//     const fetchCounties = async (stateCode) => {
//         try {
//             const response = await api.get(`/counties/${stateCode}`);
//             console.log("Counties fetched:", response.data);
//             setCounties(response.data);
//         } catch (error) {
//             console.error("Error fetching counties:", error);
//         }
//     };
    

//     const handleStateChange = (e) => {
//         const selectedState = states.find((state) => state.st_code === e.target.value);
//         setEState(selectedState.st_code);
    
//         if (selectedState.charges_countytax) {
//             setChargesCountyTax(true);
//             fetchCounties(selectedState.st_code);
//         } else {
//             setChargesCountyTax(false);
//             setCounties([]);
//             setECounty(""); // Clear the selected county
//         }
//     };
    
    

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!paymentType || !amount) {
//             alert("Please select a payment type and enter the corresponding amount.");
//             return;
//         }

//         try {
//             const requestData = {
//                 first_name: firstName,
//                 last_name: lastName,
//                 dob,
//                 hire_date,
//                 ssn,
//                 email,
//                 filing_status: filingStatus,
//                 dependents,
//                 additional_fed_tax: additionalFedTax,
//                 additional_state_tax: additionalStateTax,
//                 e_st_add: eStAdd,
//                 e_suite: eSuite,
//                 e_state: eState,
//                 e_city: eCity,
//                 e_county: eCounty || null, 
//                 e_zip: eZip,
//                 works_home: workType,
//                 payment_type: paymentType,
//                 salary_amt: paymentType === "salary" ? amount : null,
//                 hourly_amt: paymentType === "hourly" ? amount : null,
//                 employer_mandated: convenienceRuleApplies && workType === "home" ? employerMandated === "yes" : null,
//                 department_id: selectedDepartment ? parseInt(selectedDepartment) : null, // ✅ Include department ID
//                 is_direct_dep: paymentIssueType === "Direct Deposit" ? 1 : 0,
//                 account_number: paymentIssueType === "Direct Deposit" ? accountNumber : null,
//                 routing_number: paymentIssueType === "Direct Deposit" ? routingNumber : null,
//             };

//             await api.put(`/employees/${employeeId}`, requestData);
//             alert("Employee updated successfully!");
//             navigate(`/dashboard/business/${businessId}/employees`);
//         } catch (error) {
//             console.error("Error updating employee:", error);
//             alert(error.response?.data || "Failed to update employee. Please try again.");
//         }
//     };

//     const handleDisable = async () => {
//         if (window.confirm("Are you sure you want to disable this employee?")) {
//             try {
//                 await api.put(`/employees/${employeeId}/disable`);
//                 alert("Employee disabled successfully.");
//                 navigate(`/dashboard/business/${businessId}/employees`);
//             } catch (error) {
//                 console.error("Error disabling employee:", error);
//                 alert("Failed to disable employee.");
//             }
//         }
//     };

//     const handleSsnChange = (value) => {
//         // Remove all non-numeric characters
//         const numericValue = value.replace(/\D/g, '');

//         // Format as 000-00-0000
//         let formattedValue = numericValue;
//         if (numericValue.length > 3) {
//             formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
//         }
//         if (numericValue.length > 5) {
//             formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3, 5)}-${numericValue.slice(5)}`;
//         }

//         // Limit to 11 characters including dashes
//         setSsn(formattedValue.slice(0, 11));
//     };

//     if (loading) return <p className="loading">Loading employee details... Please wait.</p>;

//     return (
//         <div className="edit-employee-container">
//             <h2 className="page-header-edit">Edit Employee</h2>
//             <button className="disable-button" onClick={handleDisable}>
//                 Disable Employee
//             </button>
//             <form className="edit-employee-form" onSubmit={handleSubmit}>
//             <label className="addemplabel">
//                 Department:
//                 <select
//                     value={selectedDepartment}
//                     onChange={(e) => setSelectedDepartment(e.target.value)}
//                     required
//                 >
//                     <option value="">Select Department</option>
//                     {departments.map((dept) => (
//                         <option key={dept.id} value={dept.id}>
//                             {dept.department_name} ({dept.department_short})
//                         </option>
//                     ))}
//                 </select>
//             </label>


//             {/* Payment Issue Type Dropdown */}
//             <label className="addemplabel">
//                     Payment Issue Type:
//                     <select value={paymentIssueType} onChange={(e) => setPaymentIssueType(e.target.value)} required>
//                         <option value="">Select Payment Issue Type</option>
//                         <option value="Print Paycheck">Print Paycheck</option>
//                         <option value="Direct Deposit">Direct Deposit</option>
//                     </select>
//                 </label>

//                 {/* Show Direct Deposit Fields if Direct Deposit is Selected */}
//                 {paymentIssueType === "Direct Deposit" && (
//                     <>
//                         <label className="addemplabel">
//                             Account Number:
//                             <input type="text" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} required />
//                         </label>
//                         <label className="addemplabel">
//                             Routing Number:
//                             <input type="text" value={routingNumber} onChange={(e) => setRoutingNumber(e.target.value)} required />
//                         </label>
//                     </>
//                 )}

//                 <label className="addemplabel">
//                     First Name:
//                     <input value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
//                 </label>
//                 <label className="addemplabel">
//                     Last Name:
//                     <input value={lastName} onChange={(e) => setLastName(e.target.value)} required />
//                 </label>
//                 <label className="addemplabel">
//                     Date of Hire:
//                     <input value={hire_date} onChange={(e) => setHireDate(e.target.value)} type="date" required />
//                 </label>
//                 <label className="addemplabel">
//                     Date of Birth:
//                     <input value={dob} onChange={(e) => setDob(e.target.value)} type="date" required />
//                 </label>
//                 <label className="addemplabel">
//                     SSN:
//                     <input value={ssn} onChange={(e) => handleSsnChange(e.target.value)} required />
//                 </label>
//                 <label className="addemplabel">
//                     Email:
//                     <input
//                         type="email"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                     />
//                 </label>

//                 <label className="addemplabel">
//                     Filing Status:
//                     <select value={filingStatus} onChange={(e) => setFilingStatus(e.target.value)} required>
//                         <option value="">Select Filing Status</option>
//                         <option value="Single">Single</option>
//                         <option value="Married">Married</option>
//                         <option value="Head of Household">Head of Household</option>
//                     </select>
//                 </label>
//                 <label className="addemplabel">
//                     Dependents:
//                     <input value={dependents} onChange={(e) => setDependents(e.target.value)} type="number" />
//                 </label>
//                 <label className="addemplabel">
//                     Additional Federal Tax:
//                     <input value={additionalFedTax} onChange={(e) => setAdditionalFedTax(e.target.value)} type="number" />
//                 </label>
//                 <label className="addemplabel">
//                     Additional State Tax:
//                     <input value={additionalStateTax} onChange={(e) => setAdditionalStateTax(e.target.value)} type="number" />
//                 </label>
//                 <label className="addemplabel">
//                     Street Address:
//                     <input value={eStAdd} onChange={(e) => setEStAdd(e.target.value)} required />
//                 </label>
//                 <label className="addemplabel">
//                     Suite:
//                     <input value={eSuite} onChange={(e) => setESuite(e.target.value)} />
//                 </label>
//                 <label className="addemplabel address-row">
//                     State:
//                     <select
//                         value={eState}
//                         onChange={handleStateChange}
//                         required
//                     >
//                         <option value="">Select State</option>
//                         {states.map((state) => (
//                             <option key={state.st_code} value={state.st_code}>
//                                 {state.st_name}
//                             </option>
//                         ))}
//                     </select>
//                 </label>
//                 {/* NEW: Add county dropdown if chargesCountyTax is true */}
//                                         {/* Render County dropdown if chargesCountyTax is true OR eCounty already exists */}
//                             {chargesCountyTax && (
//                                 <label className="addemplabel address-row">
//                                     County:
//                                     <select
//                                         value={eCounty || ""}
//                                         onChange={(e) => setECounty(e.target.value)}
//                                         required
//                                     >
//                                         <option value="">Select County</option>
//                                         {counties.map((county, index) => (
//                                             <option key={index} value={county.county_name}>
//                                                 {county.county_name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </label>
//                             )}



//                 <label className="addemplabel">
//                     City:
//                     <select value={eCity} onChange={(e) => setECity(e.target.value)} required>
//                         <option value="">Select City</option>
//                         {cities.map((city, index) => (
//                             <option key={index} value={city.city_name}>
//                                 {city.city_name}
//                             </option>
//                         ))}
//                     </select>
//                 </label>
//                 <label className="addemplabel">
//                     ZIP Code:
//                     <input value={eZip} onChange={(e) => setEZip(e.target.value)} required />
//                 </label>

//                 <label className="addemplabel">
//                     Work Location:
//                     <select value={workType} onChange={(e) => setWorkType(e.target.value)} required>
//                         <option value="">Select Work Location</option>
//                         <option value="bus">Works at business location</option>
//                         <option value="home">Works from home</option>
//                     </select>
//                 </label>
//                 {convenienceRuleApplies && workType === "home" && (
//                     <label className="addemplabel">
//                         Is Remote Work Employer-Mandated?
//                         <select
//                             value={employerMandated}
//                             onChange={(e) => setEmployerMandated(e.target.value)}
//                             required
//                         >
//                             <option value="">Select</option>
//                             <option value="yes">Yes</option>
//                             <option value="no">No</option>
//                         </select>
//                     </label>
//                 )}
                
//                 <label className="addemplabel">
//                     Payment Type:
//                     <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)} required>
//                         <option value="">Select Payment Type</option>
//                         <option value="salary">Salary</option>
//                         <option value="hourly">Hourly</option>
//                     </select>
//                 </label>
//                 {paymentType && (
//                         <label className="addemplabel">
//                         {paymentType === "salary" ? "Salary per year" : "Hourly Rate"}:
//                         <input
//                             type="number"
//                             value={amount}
//                             onChange={(e) => setAmount(e.target.value)}
//                             required
//                         />
//                     </label>
//                 )}
//                 <div className="form-buttons">
//                     <button className="save-button" type="submit">
//                         Save
//                     </button>
//                     <button
//                         className="cancel-button"
//                         type="button"
//                         onClick={() => navigate(`/dashboard/business/${businessId}/employees`)}
//                     >
//                         Cancel
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default EditEmployeePage;



// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";

// const EditEmployeePage = () => {
//     const { id: businessId, employeeId } = useParams();
//     const navigate = useNavigate();

//     const [firstName, setFirstName] = useState("");
//     const [lastName, setLastName] = useState("");
//     const [dob, setDob] = useState("");
//     const [ssn, setSsn] = useState("");
//     const [filingStatus, setFilingStatus] = useState("");
//     const [dependents, setDependents] = useState(0);
//     const [additionalFedTax, setAdditionalFedTax] = useState(0);
//     const [additionalStateTax, setAdditionalStateTax] = useState(0);
//     const [eStAdd, setEStAdd] = useState("");
//     const [eSuite, setESuite] = useState("");
//     const [eState, setEState] = useState("");
//     const [eCity, setECity] = useState("");
//     const [eZip, setEZip] = useState("");
//     const [paymentType, setPaymentType] = useState("");
//     const [amount, setAmount] = useState("");

//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [loading, setLoading] = useState(true);

//     // Fetch states on component mount
//     useEffect(() => {
//         const fetchStates = async () => {
//             try {
//                 const { data } = await api.get("/states");
//                 setStates(data);
//             } catch (error) {
//                 console.error("Error fetching states:", error);
//             }
//         };

//         fetchStates();
//     }, []);

//     // Fetch employee details on component mount
//     useEffect(() => {
//         const fetchEmployeeDetails = async () => {
//             if (!businessId || !employeeId) {
//                 alert("Invalid business or employee ID.");
//                 navigate(`/dashboard`);
//                 return;
//             }

//             try {
//                 const { data } = await api.get(`/business/${businessId}/employees/${employeeId}`);

//                 const formattedDob = new Date(data.dob).toISOString().split("T")[0]; // Format DOB

//                 setFirstName(data.first_name);
//                 setLastName(data.last_name);
//                 setDob(formattedDob);
//                 setSsn(data.ssn);
//                 setFilingStatus(data.filing_status);
//                 setDependents(data.dependents);
//                 setAdditionalFedTax(data.additional_fed_tax);
//                 setAdditionalStateTax(data.additional_state_tax);
//                 setEStAdd(data.e_st_add);
//                 setESuite(data.e_suite);
//                 setEState(data.e_state);
//                 setECity(data.e_city);
//                 setEZip(data.e_zip);
//                 setPaymentType(data.salary_amt !== null ? "salary" : "hourly");
//                 setAmount(data.salary_amt ?? data.hourly_amt);
//                 setLoading(false);
//             } catch (error) {
//                 console.error("Error fetching employee details:", error.response || error.message);
//                 alert("Failed to load employee details.");
//                 navigate(`/dashboard/business/${businessId}/employees`);
//             }
//         };

//         fetchEmployeeDetails();
//     }, [businessId, employeeId, navigate]);

//     // Fetch cities when a state is selected
//     useEffect(() => {
//         const fetchCities = async () => {
//             if (eState) {
//                 try {
//                     const { data } = await api.get(`/cities/${eState}`);
//                     setCities(data);
//                 } catch (error) {
//                     console.error("Error fetching cities:", error);
//                 }
//             }
//         };

//         fetchCities();
//     }, [eState]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!paymentType || !amount) {
//             alert("Please select a payment type and enter the corresponding amount.");
//             return;
//         }

//         try {
//             const requestData = {
//                 first_name: firstName,
//                 last_name: lastName,
//                 dob,
//                 ssn,
//                 filing_status: filingStatus,
//                 dependents,
//                 additional_fed_tax: additionalFedTax,
//                 additional_state_tax: additionalStateTax,
//                 e_st_add: eStAdd,
//                 e_suite: eSuite,
//                 e_state: eState,
//                 e_city: eCity,
//                 e_zip: eZip,
//                 salary_amt: paymentType === "salary" ? amount : null,
//                 hourly_amt: paymentType === "hourly" ? amount : null,
//             };

//             await api.put(`/employees/${employeeId}`, requestData);
//             alert("Employee updated successfully!");
//             navigate(`/dashboard/business/${businessId}/employees`);
//         } catch (error) {
//             console.error("Error updating employee:", error.response?.data || error.message);
//             alert(error.response?.data || "Failed to update employee. Please try again.");
//         }
//     };

//     const handleDisable = async () => {
//         if (window.confirm("Are you sure you want to disable this employee?")) {
//             try {
//                 await api.put(`/employees/${employeeId}/disable`);
//                 alert("Employee disabled successfully.");
//                 navigate(`/dashboard/business/${businessId}/employees`);
//             } catch (error) {
//                 console.error("Error disabling employee:", error);
//                 alert("Failed to disable employee.");
//             }
//         }
//     };

//     if (loading) return <p>Loading employee details... Please wait.</p>;

//     return (
//         <div>
//             <h2>Edit Employee</h2>
//             <button onClick={handleDisable}>Disable Employee</button>
//             <form onSubmit={handleSubmit}>
//                 <input value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First Name" required />
//                 <input value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last Name" required />
//                 <input value={dob} onChange={(e) => setDob(e.target.value)} type="date" placeholder="Date of Birth" required />
//                 <input value={ssn} onChange={(e) => setSsn(e.target.value)} placeholder="SSN" required />
//                 <select value={filingStatus} onChange={(e) => setFilingStatus(e.target.value)} required>
//                     <option value="">Select Filing Status</option>
//                     <option value="Single">Single</option>
//                     <option value="Married">Married</option>
//                     <option value="Head of Household">Head of Household</option>
//                 </select>
//                 <input value={dependents} onChange={(e) => setDependents(e.target.value)} type="number" placeholder="Dependents" />
//                 <input value={additionalFedTax} onChange={(e) => setAdditionalFedTax(e.target.value)} type="number" placeholder="Additional Federal Tax" />
//                 <input value={additionalStateTax} onChange={(e) => setAdditionalStateTax(e.target.value)} type="number" placeholder="Additional State Tax" />
//                 <input value={eStAdd} onChange={(e) => setEStAdd(e.target.value)} placeholder="Street Address" required />
//                 <input value={eSuite} onChange={(e) => setESuite(e.target.value)} placeholder="Suite (Optional)" />
//                 <select value={eState} onChange={(e) => setEState(e.target.value)} required>
//                     <option value="">Select State</option>
//                     {states.map((state) => (
//                         <option key={state.st_code} value={state.st_code}>
//                             {state.st_name}
//                         </option>
//                     ))}
//                 </select>
//                 <select value={eCity} onChange={(e) => setECity(e.target.value)} required>
//                     <option value="">Select City</option>
//                     {cities.map((city, index) => (
//                         <option key={index} value={city.city_name}>
//                             {city.city_name}
//                         </option>
//                     ))}
//                 </select>
//                 <input value={eZip} onChange={(e) => setEZip(e.target.value)} placeholder="ZIP Code" required />
//                 <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)} required>
//                     <option value="">Select Payment Type</option>
//                     <option value="salary">Salary</option>
//                     <option value="hourly">Hourly</option>
//                 </select>
//                 {paymentType && (
//                     <input
//                         type="number"
//                         value={amount}
//                         onChange={(e) => setAmount(e.target.value)}
//                         placeholder={paymentType === "salary" ? "Enter Salary" : "Enter Hourly Rate"}
//                         required
//                     />
//                 )}
//                 <button type="submit">Save Changes</button>
//                 <button type="button" onClick={() => navigate(`/dashboard/business/${businessId}/employees`)}>
//                     Cancel
//                 </button>
//             </form>
//         </div>
//     );
// };

// export default EditEmployeePage;




